// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"c77931e4","516":"1d93a139","860":"cd906bca"}[chunkId] + ".css";
};